import EventContainer from '../../../../common/event/EventContainer';
import IWidgetConfiguration from '../../../../common/model/IWidgetConfiguration';
import { createContext } from 'react';

const WidgetContext = createContext<[IWidgetConfiguration, EventContainer] | null>(null);

export default WidgetContext;
